<ion-text>
  <p class="font-text">
    O projeto de regularização foi desenvolvido e enviado para a análise da prefeitura.
  </p>
  <p class="font-text">
    Aguarde a aprovação e publicação do processo de regularização no Diário Oficial.
  </p>
</ion-text>
